import { downloadToCSV, downloadToPNG, type DownloadItem } from '../../actions'
import type { ConfigProps } from '../../loader/types'

export function createChartDownloadConfig<TData>(
  csvModifier: (data: TData) => string[][],
) {
  return function ({ refUI }: ConfigProps): DownloadItem<TData>[] {
    return [
      {
        ...downloadToPNG,
        modifier: () => downloadToPNG.modifier(refUI),
      },
      {
        ...downloadToCSV,
        modifier: async (data) => {
          const rows = csvModifier(data)
          return downloadToCSV.modifier(rows)
        },
      },
    ]
  }
}
